import { __awaiter } from "tslib";
import { alas, status } from '@/alas';
import { showError, showSuccess } from '@/store';
import { defineComponent, reactive, onMounted, ref } from '@vue/composition-api';
export default defineComponent({
    computed: {
        alas: () => alas
    },
    setup(props, context) {
        let t = m => context.root.$t(m);
        let router = context.root.$router;
        // ================
        //
        // ref
        //
        let user = ref(status.fetch('user'));
        // ================
        //
        // state
        //
        let state = reactive({
            loading: false,
            username: '',
            resetMode: false,
            verifyCode: '',
            newPassword1: '',
            newPassword2: '',
            validate: false
        });
        // ================
        //
        // mounted
        //
        onMounted(() => {
            if (user.value.$v.logged) {
                router.push({
                    name: 'home'
                });
            }
        });
        // ================
        //
        // methods
        //
        let samePassword = () => {
            return state.newPassword1 !== state.newPassword2 ? t('密碼不同') : true;
        };
        let confirmForgotPassword = () => __awaiter(this, void 0, void 0, function* () {
            state.loading = true;
            try {
                yield user.value.$o.forgotPassword.start({
                    username: state.username
                });
                state.resetMode = true;
            }
            catch (error) {
                showError(error);
            }
            finally {
                state.loading = false;
            }
        });
        let confirm = () => __awaiter(this, void 0, void 0, function* () {
            state.loading = true;
            try {
                yield user.value.$o.forgotPasswordSubmit.start({
                    code: state.verifyCode,
                    username: state.username,
                    password: state.newPassword1
                });
                showSuccess(t('修改成功'));
                router.push({
                    name: 'account.login'
                });
            }
            catch (error) {
                showError(error);
            }
            finally {
                state.loading = false;
            }
        });
        // ================
        //
        // done
        //
        return {
            user,
            state,
            confirmForgotPassword,
            confirm,
            samePassword
        };
    }
});
